import {CouponListHeader} from './components/header/CouponListHeader'
import {CouponTable} from './table/CouponTable'
import {KTCard} from '../../../../../_metronic/helpers'
import {useContext} from 'react'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {AlertBox} from '../../../../../_metronic/layout/components/alert-message'

const CouponList = () => {
  return (
    <>
      <KTCard>
        <CouponListHeader />
        <CouponTable />
      </KTCard>
    </>
  )
}

const MainPage = () => {
  return (
    <>
      <div className='row'>
        <div className='col-lg-12'>
          <CouponList />
        </div>
      </div>
    </>
  )
}

const CouponListWrapper = () => (
  <MainPage />
)

export {CouponListWrapper}
